import {useEffect, useMemo, useState} from 'react';
import {getOrElse, initial, isPending} from '../../common/domain/RemoteData.model';
import {remoteDataWithSetter} from '../../common/utils/remoteDataWithSetter';
import {getCatalogItemPrices} from '../domain/CatalogService';

export const useCatalogPricesRemoteData = (catalogItemsRemoteData) => {
  const [catalogItemPricesRemoteData, setCatalogItemPricesRemoteData] = useState(initial({}));
  const [isDelayedFetchTriggered, setIsDelayedFetchTriggered] = useState(false);

  const shouldFetchPrices = useMemo(() => {
    const catalogItems = getOrElse(catalogItemsRemoteData, []);
    return catalogItems.length > 0;
  }, [catalogItemsRemoteData]);

  const fetchCondition = useMemo(() => {
    return {
      shouldFetchPrices,
      catalogItemsValue: catalogItemsRemoteData.value
    };
  }, [shouldFetchPrices, catalogItemsRemoteData.value]);

  useEffect(() => {
    const triggerFetch = () => {
      const fetchPrices = () => getCatalogItemPrices(fetchCondition.catalogItemsValue);
      remoteDataWithSetter(setCatalogItemPricesRemoteData, fetchPrices).then(() => {
        setIsDelayedFetchTriggered(false);
      });
    };

    if (fetchCondition.shouldFetchPrices) {
      if (isPending(catalogItemPricesRemoteData)) {
        if (!isDelayedFetchTriggered) {
          const timeoutId = setTimeout(() => {
            triggerFetch();
          }, 2000);

          setIsDelayedFetchTriggered(true);

          return () => clearTimeout(timeoutId);
        }
      } else {
        triggerFetch();
        setIsDelayedFetchTriggered(false);
      }
    }
  }, [fetchCondition, isDelayedFetchTriggered]);

  return { catalogItemPricesRemoteData };
};
